import React, { lazy } from 'react';
import { Switch, Route } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';

const Performance = lazy(() => import('../../container/dashboard/Performance'));
const PerformanceProjetos = lazy(() => import('../../container/dashboardprojects/Performance'));

const DashboardRoutes = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={path} component={Performance} />
      <Route exact path={path + "projetos"} component={PerformanceProjetos} />
    </Switch>
  );
};

export default DashboardRoutes;
